import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://yrqtkeyygccavjinbtar.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlycXRrZXl5Z2NjYXZqaW5idGFyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzMTY0MTIsImV4cCI6MjA3NTg5MjQxMn0.EWN8VALQoFh3HHTPWp5iEWCYTCZEIazwMEpmjIVOH90'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)